import {DOMNode, HTMLReactParserOptions, domToReact} from 'html-react-parser';
import Link from 'next/link';

export const parseOptions: HTMLReactParserOptions = {
  replace: (node, index) => {
    if (node.type === 'tag' && node.name === 'a' && node.children) {
      const href = node.attribs?.href || '/';
      const target = node.attribs?.target;
      return (
        <Link
          target={target}
          className="styled-link"
          href={`${href || '/'}`}
          key={index}>
          <strong className="font-semibold">
            {domToReact(node.children as DOMNode[], parseOptions)}
          </strong>
        </Link>
      );
    }
  },
};
